<template>
  <div class="wrapper signin__image--bg">
    <section class="signin">
      <div class="signin__image">
        <p>入力されたメールアドレスへ</p>
        <p>パスワード再設定用のメールをお送りします。</p>
      </div>
      <div class="signin__input">
        <input type="email" v-model="param_reset.mail_address" placeholder="メールアドレスを入力してください">
      </div>
      <button type="submit" class="signin__button" :class="{active: is_active}" @click="reset">送信</button>
    </section>
  </div>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		data() {
			return {
				param_reset: {
					mail_address: ""
				},
        is_active: false,
			}
		},
		methods: {
			// 認証コード発行
			async reset() {
			  if (!this.is_active) {
			    return
        }
				if (this.param_reset.mail_address !== "") {
					await this.$store.dispatch('authorize/resetApi', this.param_reset)
					if (this.resetApiStatus) {
					  this.$router.push('remind_password_setting')
					}
				}
				else {
					navigator.notification.alert(
							'メールアドレスが入力されていません。',
							null,
							'',
							'OK'
					)
				}
			},
		},
    watch: {
		  param_reset: {
		    handler(value) {
		      this.is_active = value.mail_address !== ""
        },
        deep: true
      }
    },
		computed: {
			...mapState({
				resetApiStatus: state => state.authorize.apiStatus
			})
		}
	}
</script>
